import ajax from './ajax'
const baseUrl = '/api'

//获取配置
export const getConfig = (keys) => ajax.request(baseUrl + '/home/GetConfig', { keys }, 'POST')

//登录
export const reqTeaLogin = ({ mobile, passWord, captcha, capguid }) => ajax.request(baseUrl + '/Teacher/User/Login', { mobile, passWord, captcha, capguid }, 'POST')

//图形验证码
export const getLoginCaptcha = () => ajax.request(baseUrl + '/Captcha/GetPictureCaptcha',)

//首页 赛事列表
export const reqIndexList = (_curPage, _pageSize) => ajax.request(baseUrl + '/Contest/Teacher/GetMatchList', { _curPage, _pageSize }, 'POST')

//首页 赛事详情
export const reqMatchDetail = (matchId) => ajax.request(baseUrl + '/Contest/Teacher/GetMatch', { matchId }, 'POST')

//是否加入比赛
export const reqIsApply = (matchId) => ajax.request(baseUrl + '/Contest/Teacher/IsApply', { matchId }, 'POST')

//获取学段,学科,教材版本
export const getBookVersion = (matchId) => ajax.request(baseUrl + '/Contest/Teacher/GetBookVersion', { matchId }, 'POST')

//获取教材目录
export const getCatalogue = (bookVersionId) => ajax.request(baseUrl + '/Contest/Teacher/GetCatalogue', { bookVersionId }, 'POST')

//aliyun
export const getAliOss = () => ajax.request(baseUrl + '/AliOss/Get')

//文件上传
export const uploadFile = (OssKey) => ajax.request(baseUrl + '/AliOss/Upload', { OssKey }, 'POST', { showLoading: false })

//上传作品
export const uploadWork = (data) => ajax.request(baseUrl + '/Contest/Teacher/UploadWork', data, 'POST')

//我的作品列表
export const getWorkList = (status, _curPage, _pageSize) => ajax.request(baseUrl + '/Contest/Teacher/GetWorkList', { status, _curPage, _pageSize }, 'POST')

//作品详情
export const getWork = (workId) => ajax.request(baseUrl + '/Contest/Teacher/GetWork', { workId }, 'POST')

//提交作品
export const submitWork = (workId) => ajax.request(baseUrl + '/Contest/Teacher/SubmitWork', { workId }, 'POST')

//取消提交
export const cancelSubmitWork = (workId) => ajax.request(baseUrl + '/Contest/Teacher/CancelSubmitWork', { workId }, 'POST')

//删除作品
export const deleteWork = (workId) => ajax.request(baseUrl + '/Contest/Teacher/DeleteWork', { workId }, 'POST')

//更新作品
export const updateWork = (data) => ajax.request(baseUrl + '/Contest/Teacher/UpdateWork', data, 'POST')

//比赛结果
export const getMatchResult = (matchId, workId) => ajax.request(baseUrl + '/Contest/Teacher/GetMatchResult', { matchId, workId }, 'POST')



//评委端
// 登录
export const reqJudgeLogin = ({ AccountNumber, Password, captcha, capguid }) => ajax.request(baseUrl + '/Contest/Judges/LoginJudges', { AccountNumber, Password, captcha, capguid }, 'POST')

// 大赛列表
export const judgeIndexList = (_curPage, _pageSize) => ajax.request(baseUrl + '/Contest/Judges/GetMatchList', { _curPage, _pageSize }, 'POST')

//评审作品列表
export const getJudgeList = (type, MatchId, _curPage, _pageSize) => ajax.request(baseUrl + '/Contest/Judges/GetWorksList', { type, MatchId, _curPage, _pageSize }, 'POST')

//当前大赛进度
export const getWorksTotalInfo = (MatchId) => ajax.request(baseUrl + '/Contest/Judges/GetWorksTotalInfo', { MatchId }, 'POST')

//获取作品信息和评分情况
export const getJudgeWorksInfo = (MatchId, WorksId) => ajax.request(baseUrl + '/Contest/Judges/GetWorksInfo', { MatchId, WorksId }, 'POST')

//评分/修改评分
export const setScore = (data) => ajax.request(baseUrl + '/Contest/Judges/SetScore', data, 'POST')

// 获取全部作品Id
export const getWorksIdList = (MatchId) => ajax.request(baseUrl + '/Contest/Judges/GetWorksIdList', { MatchId }, 'POST')

//颁奖人登录
export const loginAward = ({ account, password, captcha, capguid }) => ajax.request(baseUrl + '/Award/Data/Login', { account, password, captcha, capguid }, 'POST')
//比赛列表
export const getMatchs = (_curPage, _pageSize) => ajax.request(baseUrl + '/Award/Data/GetMatchs', { _curPage, _pageSize }, 'POST')
//颁奖作品
export const getWorks = (data) => ajax.request(baseUrl + '/Award/Data/GetWorks', data, 'POST')
//颁奖多个
export const AwardWorks = (data) => ajax.request(baseUrl + '/Award/Data/WorksAward', data, 'POST')
//颁奖单个
export const WorkAward = (data) => ajax.request(baseUrl + '/Award/Data/WorkAward', data, 'POST')
//作品详情
export const workInfo = (data) => ajax.request(baseUrl + '/Award/Data/GetWork', data, 'POST')
//比赛奖项
export const matchAward = (data) => ajax.request(baseUrl + '/Award/Data/GetMatchAward', data, 'POST')

//修改密码

export const changePwd = (data) => ajax.request(baseUrl + '/Contest/Judges/UpdatePassword', data, 'POST')

export const changePwdAward = (data) => ajax.request(baseUrl + '/Award/Data/UpdatePassword', data, 'POST')



// WEBPACK FOOTER //
// ./src/api/index.js